<a href="{href}" class={className} {...normalisedDataAttributes}>
  <Logo alt="{alt}" {className} />
</a>

<style lang="less">
  @import (reference) '../../less/variables';

  a {
    margin: 0;
    display: inline-block;

    height: @masthead-logo-height-default;
    width: @masthead-logo-width-default;

    @media (min-width: @breakpoint-tablet) {
      height: @masthead-logo-height-large;
      width: @masthead-logo-width-large;
    }
  }
</style>

<script>
  import { normaliseDataAttributes } from '../../lib/normaliseDataAttributes';
  import Logo from './Logo.html';

  export let href;
  export let alt;
  export let className;
  export let dataAttributes = {};

  $: normalisedDataAttributes = normaliseDataAttributes(dataAttributes);
</script>
